<template>
    <div>
        <el-button type="info" @click="dialogFormVisible = true" icon="el-icon-user">登录</el-button>
        <el-dialog :visible.sync="dialogFormVisible" :style="{'width':'600px'}" center>
            <loginform @loginSuccess="login" ></loginform>
        </el-dialog>
    </div>
</template>

<script>
    import Loginform from "../../../../components/loginform/Loginform";
    export default {
        name: "UserLoadTool",
        data() {
            return {
                dialogFormVisible: false,
                // loginUser:{
                //     username: '',
                //     password:'',
                // },
                // value: '100',

            };
        },
        components:{
            Loginform,
        },
        methods: {
            login(ruleForm) {
                // this.loginUser.username=ruleForm.userAccount;
                // this.loginUser.password=ruleForm.pass;
                console.log(ruleForm.userAccount);
                this.$store.dispatch('requireWordLogin', ruleForm).then(res => {
                    this.$message({
                        message: '恭喜' + res + ',你已成功登陆',
                        type: 'success'
                    });
                    this.dialogFormVisible = false;
                });

            },
        }
    }
</script>

<style scoped>

</style>